import {START_STREAMING as SOCKET_START_STREAMING} from '../../events/DashboardToServer'
import {STOP_STREAMING as SOCKET_STOP_STREAMING} from '../../events/DashboardToServer'

export const START_STREAMING = 'START_STREAMING'
export const STOP_STREAMING = 'STOP_STREAMING'
export const STREAMING_STARTED = 'STREAMING_STARTED'
export const STREAMING_STOPPED = 'STREAMING_STOPPED'


export const live_video_url = (state = null, action) => {
    switch (action.type) {
    
        case STREAMING_STARTED:
            return action.live_video_url

        case STREAMING_STOPPED:
            return null

        default:
            return state
    }
}

export const streamingStarted = (live_video_url) => {
    return { type: STREAMING_STARTED,  live_video_url}
}

export const streamingStopped = () => {
    return { type: STREAMING_STOPPED}
}

export const startStreaming = (socket,live_video_url) => {
    socket.emit(SOCKET_START_STREAMING, {live_video_url});
    return { type: START_STREAMING,  live_video_url}
}

export const stopStreaming = (socket) => {
    socket.emit(SOCKET_STOP_STREAMING);
    return { type: STOP_STREAMING}
}


// WEBPACK FOOTER //
// ./src/reducers/liveVideoUrl/index.js